import { jsxs as d, jsx as i } from "react/jsx-runtime";
import { useTranslation as h, useMasterData as f, RadioButton as v, Theme as k } from "@nextgen-web-framework/all";
import { AccountStatus as g } from "./components/multi-account-selector/types/enums.js";
import './assets/AccountListItem.css';const b = "#ffffff", y = "#396e75", B = "#e5fdff", I = "#546223", $ = "#f0fae5", A = "#a65523", N = "#fff1e8", G = "#7f3e3e", O = "#ffe2e2", R = "#62625a", p = "#f8f8e7", w = "#38539a", E = "#707070", L = "#c8f8d1", T = "#87c9c8", W = "#5291b1", P = "rgba(82, 145, 177, 0.1019607843)", Y = "#445685", x = "#181d61", j = "rgba(24, 29, 97, 0.1019607843)", M = "#5969d6", U = "#ea999d", H = "#b6577e", X = "rgba(182, 87, 126, 0.1019607843)", q = "#7e3e80", D = "#1e247f", F = "rgba(30, 36, 127, 0.1019607843)", J = "#da7600", K = "#107f47", Q = "#d91734", Z = "_html_1menr_46", S = "_name_1menr_117", tt = "_tag_1menr_138", at = "_status_1menr_146", t = {
  amwayWhite: b,
  darkBlue: y,
  lightBlue: B,
  darkGreen: I,
  lightGreen: $,
  darkOrange: A,
  lightOrange: N,
  darkRed: G,
  lightRed: O,
  darkYellow: R,
  lightYellow: p,
  darkPurple: w,
  darkGrayOnWhite: E,
  dataVizColor1: L,
  dataVizColor2: T,
  dataVizColor3: W,
  dataVizColor3Background: P,
  dataVizColor4: Y,
  dataVizColor5: x,
  dataVizColor5Background: j,
  dataVizColor6: M,
  dataVizColor7: U,
  dataVizColor8: H,
  dataVizColor8Background: X,
  dataVizColor9: q,
  dataVizColor10: D,
  dataVizColor10Background: F,
  dataVizAlertOrange: J,
  dataVizSuccessGreen: K,
  dataVizWarningRed: Q,
  "no-visible": "_no-visible_1menr_42",
  html: Z,
  "identity-account-list": "_identity-account-list_1menr_80",
  "identity-account-list-item": "_identity-account-list-item_1menr_91",
  "left-container": "_left-container_1menr_106",
  name: S,
  "name-active": "_name-active_1menr_123",
  "role-active": "_role-active_1menr_126",
  "number-active": "_number-active_1menr_129",
  "right-container": "_right-container_1menr_132",
  tag: tt,
  "status-active": "_status-active_1menr_146",
  "status-inactive": "_status-inactive_1menr_161",
  "identity-account-list-item-active": "_identity-account-list-item-active_1menr_176",
  "identity-account-list-item-disabled": "_identity-account-list-item-disabled_1menr_179",
  status: at,
  "skeleton-loading": "_skeleton-loading_1menr_1"
}, rt = ({
  accountName: u,
  accountNumber: o,
  accountStatus: r,
  selectedAccountNumber: V,
  setSelectedAccountNumber: s
}) => {
  var m;
  const l = h(), { NEXT_PUBLIC_TENANT_NAME: z } = ConfigService.getConfigs(), a = f("IdentityConfig"), e = V == o;
  let n = !1;
  const c = ((m = a == null ? void 0 : a.tenants) == null ? void 0 : m[z]) || (a == null ? void 0 : a.default);
  (c == null ? void 0 : c.disableInactiveAccounts) && (n = r === g.INACTIVE);
  const _ = () => {
    n || s == null || s(o);
  }, C = l("identity.AccountListItem.aboNoLabel");
  return /* @__PURE__ */ d(
    "div",
    {
      className: `${t["identity-account-list-item"]} ${e ? t["identity-account-list-item-active"] : ""} ${n ? t["identity-account-list-item-disabled"] : ""}`,
      onClick: _,
      role: "presentation",
      children: [
        /* @__PURE__ */ d("div", { className: t["left-container"], children: [
          /* @__PURE__ */ i("div", { className: `${t.name} ${e ? t["name-active"] : ""}`, children: u }),
          /* @__PURE__ */ i(
            "div",
            {
              className: `${t.number} ${e ? t["number-active"] : ""}`,
              children: `${C}: ${o}`
            }
          )
        ] }),
        /* @__PURE__ */ i("div", { className: t["right-container"], children: /* @__PURE__ */ d("div", { className: t.tag, children: [
          /* @__PURE__ */ i(
            "div",
            {
              className: `${r === g.INACTIVE ? t["status-inactive"] : t["status-active"]}`,
              children: l(`identity.AccountListItem.${r}`)
            }
          ),
          /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i(v, { theme: k.PURPLE, checked: e, onClick: _, disabled: n }) })
        ] }) })
      ]
    }
  );
};
export {
  rt as A,
  t as s
};
//# sourceMappingURL=AccountListItem-18933ba7.mjs.map
